import { useEffect, useRef } from 'react';

export default function MouthpieceDoctor() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .fade-left, .fade-right').forEach((el) => {
              el.classList.add('visible');
            });
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 fade-up">
          <div className="flex flex-col md:flex-row gap-8 items-start mb-8">
            <div className="w-24 h-24 md:w-64 md:h-auto flex-shrink-0 mx-auto md:mx-0 fade-left">
              <img
                alt="谷口正昭 歯科医師"
                className="w-full h-full object-cover object-top rounded-full md:rounded-lg"
                src="https://storage.readdy-site.link/project_files/8b218f61-770c-4aa3-91e8-64d321e8d024/d004c8b4-dbf7-433e-9a7c-d37caec86074_202406140121.jpg"
              />
            </div>
            <div className="flex-1 fade-right">
              <h3 className="text-2xl font-bold text-gray-900 mb-2 font-serif">谷口 正昭</h3>
              <p className="text-gray-600 mb-6">歯科医師/医療法人mirai 理事長</p>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>矯正治療は、「始めること」より「納得して始めること」が大切だと考えています。</p>
                <p>当院では、診査データをもとにした「あなた専用 矯正プラン比較レポート」を無料で作成・提供しています。費用・期間・リスクを整理した上で、患者さん自身が比較・判断できる状態をつくることを大切にしています。</p>
                <p>その場で決める必要はありません。まずは一度、ご相談ください。</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 fade-up">
            <a
              href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer hover:opacity-90"
              style={{ backgroundColor: '#3E5F8F' }}
            >
              無料診断を予約する
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#report"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-lg text-lg font-semibold border-2 transition-all whitespace-nowrap cursor-pointer hover:bg-gray-50"
              style={{ borderColor: '#3E5F8F', color: '#3E5F8F' }}
            >
              レポートの内容を見る
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}